import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Text } from '@library';
import type { AdditionalCharges } from '../../types';
import usePriceFormatter from '../../../core/hooks/usePriceFormatter';

const ProductAdditionalCharges = memo(
    ({
        quantity,
        additionalCharges,
    }: {
        quantity: number;
        additionalCharges: AdditionalCharges[];
    }) => {
        const sum = additionalCharges.reduce((result, current) => {
            return result + parseFloat(current.chargeExcl);
        }, 0);

        const formatter = usePriceFormatter();
        return (
            <div>
                {sum > 0 && (
                    <Text tertiary>
                        {quantity > 0 ? (
                            <FormattedMessage
                                id="For this article there are additional fees totaling {price}."
                                values={{
                                    price: formatter(sum * quantity).priceLabel,
                                }}
                            />
                        ) : (
                            <FormattedMessage
                                id="For this article there are additional fees of {price} per item."
                                values={{ price: formatter(sum).priceLabel }}
                            />
                        )}
                    </Text>
                )}
            </div>
        );
    }
);

export default ProductAdditionalCharges;
